import React from "react";

function DashboardStats({ stats }) {
  if (!stats) return <p className="loading-text">Loading stats...</p>;

  const totalProfit = Number(stats.total_profit || 0);
  const winRate = Number(stats.win_rate || 0);
  const totalTrades = Number(stats.total_trades || 0);
  const wins = Number(stats.wins || 0);
  const losses = Number(stats.losses || 0);
  const momentum = Math.min(100, Math.round(winRate + wins * 2));

  return (
    <div className="stats-row">
      <div className="stat-card">
        <h3>Total PNL</h3>
        <p className={`big-stat ${totalProfit >= 0 ? "green-text" : "red-text"}`}>
          {totalProfit >= 0 ? "+" : "-"}${Math.abs(totalProfit).toFixed(2)}
        </p>
        <span>{totalTrades} total trades</span>
      </div>

      <div className="stat-card">
        <h3>Win Rate</h3>
        <p className="big-stat green-text">{winRate.toFixed(1)}%</p>
        <span>{wins} wins · {losses} losses</span>
      </div>

      <div className="stat-card hero-stat">
        <h3>Trader Momentum</h3>
        <p className="big-stat blue-text">{momentum}</p>
        <span>Live dashboard score</span>
      </div>
    </div>
  );
}

export default DashboardStats;